function AiSparklesIcon({ className }: { className?: string }) {
    return (
        <svg className={className} width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path
                d="M9.5 2.5 C9.5 7 13 10.5 17.5 10.5 C13 10.5 9.5 14 9.5 18.5 C9.5 14 6 10.5 1.5 10.5 C6 10.5 9.5 7 9.5 2.5 Z"
                fill="#EBF253"
            />
            <path
                d="M18.5 3.5 C18.5 5.7 20.3 7.5 22.5 7.5 C20.3 7.5 18.5 9.3 18.5 11.5 C18.5 9.3 16.7 7.5 14.5 7.5 C16.7 7.5 18.5 5.7 18.5 3.5 Z"
                fill="#EBF253"
            />
            <path
                d="M17.5 14.5 C17.5 16.15 18.85 17.5 20.5 17.5 C18.85 17.5 17.5 18.85 17.5 20.5 C17.5 18.85 16.15 17.5 14.5 17.5 C16.15 17.5 17.5 16.15 17.5 14.5 Z"
                fill="#EBF253"
            />
        </svg>
    );
}

export default AiSparklesIcon;
